import {isLoggedIn} from 'utils/auth'
import {injectReducer} from '../../store/reducers';
import {filterValuesReducer} from '../Home/modules/home';

export default (store) => ({
  path: 'detailed-analytics',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer})
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const detailedAnalytics = require('./containers/DetailedAnalyticsContainer').default;
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer, loadBrandNamesReducer} = require('../SalesAnalytics/modules/salesAnalytics');
      const {loadStoreWiseTotalSalesReducer, loadCategoryWiseTotalSalesReducer, loadStoreWiseSalesComparisonReducer, loadCategoryWiseSalesComparisonReducer,loadSalesChannelsReducer} = require('./modules/DetailedAnalytics');

      injectReducer(store, {key: 'storeWiseTotalSales', reducer: loadStoreWiseTotalSalesReducer});
      injectReducer(store, {key: 'categoryWiseTotalSales', reducer: loadCategoryWiseTotalSalesReducer});
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer});
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer});
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer});
      injectReducer(store, {key: 'storeWiseSalesComparison', reducer: loadStoreWiseSalesComparisonReducer});
      injectReducer(store, {key: 'categoryWiseSalesComparison', reducer: loadCategoryWiseSalesComparisonReducer});
      injectReducer(store, {key: 'channels', reducer: loadSalesChannelsReducer});

      /*  Return getComponent   */
      callback(null, detailedAnalytics)

      /* Webpack named bundle   */
    }, 'DetailedAnalyticsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/DetailedAnalytics/index.js